<template>
    <div class="hts-distributing__detail">
        <div class="flex justify-between">
            <action-tabs />
            <hts-form-input
                v-model="search"
                class="w-72"
                :placeholder="$t('labels.findJourney')"
                @change="searchChange">
                <template #prefix>
                    <hi-magnifying-glass-icon class="h-6 w-6 ml-2 text-gray-500" />
                </template>
            </hts-form-input>
        </div>

        <div class="mt-3 h-[420px] max-h-[420px]">
            <hts-data-table
                ref="dataTables"
                class="w-full"
                use-selection
                :is-select-all-table="false"
                :headers="headers"
                :server="server"
                row-selection="single"
                @selection-changed="journeyChange" />
        </div>
    </div>
</template>
<script setup lang="ts">
import ActionTabs from './action-tabs.vue'

/** Define */
const { $formatters } = useNuxtApp()

/** Variables */
const loading = ref(false)
const headers = ref([
  {
    field: 'code',
    headerName: $t('labels.code'),
    sortable: true,
    filter: 'agTextColumnFilter'
  },
  {
    field: 'journeyName',
    headerName: $t('labels.journey2')
  },
  {
    field: 'fleetVehicleName',
    headerName: $t('labels.fleetVehicle')
  },
  {
    field: 'transportation',
    sortable: true,
    headerName: $t('labels.transportation'),
    valueGetter: (params: any) => {
      const transportation = params?.data.orderData?.transportation
      if (transportation === 'CONTAINER') {
        return $t('labels.containerTruck')
      }
      if (transportation === 'NON_CONTAINER') {
        return $t('labels.nonContainerTruck')
      }
    }
  },
  {
    field: 'contCategory',
    headerName: $t('labels.cont'),
    valueGetter: (params: any) => {
      const contCategory = params.data?.orderData?.contCategory
      if (contCategory) {
        if (contCategory === 20) {
          return $t('labels.20f')
        }
        if (contCategory === 40) {
          return $t('labels.40f')
        }
        if (contCategory === 45) {
          return $t('labels.45f')
        }
      }
    }
  },
  {
    field: 'mergeContainer',
    headerName: $t('labels.mergeContainer'),
    valueGetter: (params: any) => {
      const mergeContainer = params?.data?.orderData?.mergeContainer
      if (mergeContainer) {
        return $t('labels.haveMergeContainer')
      }
      return $t('labels.notMergeContainer')
    }
  },
  {
    field: 'headContainer',
    headerName: $t('labels.headContainer'),
    valueGetter: (params: any) => {
      const headContainer = params?.data?.orderData?.headContainer
      if (headContainer) {
        return $t('labels.true')
      }
      return $t('labels.false')
    }
  },
  {
    field: 'commodityName',
    headerName: $t('labels.commodity'),
    valueGetter: (params: any) => {
      const commodityName = params?.data?.orderData?.commodityName
      const commodityCategory = params?.data?.orderData?.commodityCategory
      if (commodityName && commodityCategory) {
        return `${commodityName} - ${commodityCategory}`
      }
      if (commodityName) {
        return commodityName
      }
      return ''
    }
  },
  {
    field: 'weightCommodity',
    headerName: $t('labels.weightCommodityByKG1'),
    valueGetter: (params: any) => {
      return $formatters.formatNumber(params.data.orderData?.weightCommodity)
    }
  },
  // {
  //   field: 'status',
  //   headerName: $t('labels.fleetVehicleConfirm'),
  //   valueGetter: (params:any) => {
  //     const status = params.data.status
  //     if (status === -1) {
  //       return $t('labels.cancel')
  //     }
  //     if (status === 0) {
  //       return $t('labels.reject')
  //     }
  //     if (status === 1) {
  //       return $t('labels.waitingConfirm')
  //     }
  //     if (status === 2) {
  //       return $t('labels.confirm')
  //     }
  //     return ''
  //   }
  // },
  {
    field: 'createdAt',
    headerName: $t('labels.createdAt'),
    sortable: true,
    filter: 'agDateColumnFilter',
    valueGetter: (params: any) => {
      return $formatters.datetime(params.data.createdAt)
    }
  },
  {
    field: 'updatedAt',
    headerName: $t('labels.updatedAt'),
    sortable: true,
    filter: 'agDateColumnFilter',
    valueGetter: (params: any) => {
      return $formatters.datetime(params.data.updatedAt)
    }
  }
])
const dataTables = ref()
const server = $url.trip.journey['get-list']
const search = ref('')

const findKey = ref('')

/** Methods */
const searchChange = $lodash.debounce(() => {
  if (dataTables.value) {
    dataTables.value.setFilterModel({
      code: {
        filter: findKey.value,
        filterType: 'text',
        type: 'contains'
      },
      journeyName: {
        filter: findKey.value,
        filterType: 'text',
        type: 'contains'
      }
    })
  }
}, 500)

const journeyChange = (journeys: any) => {
  const positions = journeys?.value?.[0]?.journey
  try {
    let check = true
    if (positions?.length) {
      if (!positions[0].lat || !positions[0].lng) {
        check = false
      }
      const origin = {
        lat: parseFloat(positions[0].lat),
        lng: parseFloat(positions[0].lng)
      }
      positions.splice(0, 1)
      if (!positions[positions.length - 1].lat || !positions[positions.length - 1].lng) {
        check = false
      }
      const destination = {
        lat: parseFloat(positions[positions.length - 1].lat),
        lng: parseFloat(positions[positions.length - 1].lng)
      }
      positions.splice(positions.length - 1, 1)
      const waypoints: { location: google.maps.LatLngLiteral }[] = []
      positions.forEach((position: any) => {
        if (!position.lat || !position.lng) {
          check = false
        }
        const waypoint = {
          location: {
            lat: parseFloat(position.lat),
            lng: parseFloat(position.lng)
          }
        }
        waypoints.push(waypoint)
      })

      if (check) {
        journeyRoute.value = {
          originData: origin,
          destinationData: destination,
          waypointsData: waypoints
        }
      } else {
        journeyRoute.value = null
      }
    }
  } catch (e) {}
}
</script>
